import axios from 'axios';
import { getOrganizationSettings } from './utils/storage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export default api;




export async function getCableSubscriptions(cable_tv_type) {
  const token = localStorage.getItem('token');
  const newOrg = getOrganizationSettings();

  const appid = newOrg.id;
  const res = await api.get(`transactions/get-subscriptions?cableTvType=${cable_tv_type}`, {
    headers: {
      'Accept': 'application/json',
      'AppID': appid,
      'Authorization': `Bearer ${token}`
    }
  });
  return res.data;
}

